import { Utils } from 'formiojs';
import { form as template } from 'src/formio/templates/paginationComponent/form';

const compiledForm = Utils.Evaluator.template(template, 'paginationComponent');
export const formioPaginationComponentCustomTemplate = (ctx: any) => {
    return compiledForm(ctx);
};
